import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { BatchPutGeofenceRequestFilterSensitiveLog, } from "../models/models_0";
import { de_BatchPutGeofenceCommand, se_BatchPutGeofenceCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class BatchPutGeofenceCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("LocationService", "BatchPutGeofence", {})
    .n("LocationClient", "BatchPutGeofenceCommand")
    .f(BatchPutGeofenceRequestFilterSensitiveLog, void 0)
    .ser(se_BatchPutGeofenceCommand)
    .de(de_BatchPutGeofenceCommand)
    .build() {
}
